/**
 * Providers - 应用根组件
 * 提供所有必要的 Context Provider
 */
import React from "react";
import { NavigationContainer } from "@react-navigation/native";
import { UserProvider } from "../store/UserStore";
import { SwitchProvider } from "../store/SwitchAccStore";
import { SafeAreaProvider } from "../utils/shims/safe-area-context";
import { GestureHandlerRootView } from "../utils/shims/gesture-handler";
import MenuProvider from "../components/popupmenu/MenuProvider";
import App from "../../App";

console.log('🔧 [Providers] 文件开始加载...');

export const Providers = () => {
  console.log('🔧 [Providers] Providers 组件渲染中...');
  
  React.useEffect(() => {
    console.log('✅ [Providers] Providers 组件已挂载');
    return () => {
      console.log('🔧 [Providers] Providers 组件卸载');
    };
  }, []);

  return (
    <NavigationContainer>
      <SafeAreaProvider>
        <UserProvider>
          <SwitchProvider>
            <GestureHandlerRootView style={{ flex: 1 }}>
              <MenuProvider>
                <App />
              </MenuProvider>
            </GestureHandlerRootView>
          </SwitchProvider>
        </UserProvider>
      </SafeAreaProvider>
    </NavigationContainer>
  );
};

